import { FoodLogOnDate } from "@corpuscomplete/core-ui/nutrition/food-log";
import { FoodLogDatePage } from "@corpuscomplete/web/modules/nutrition/food-log/pages/food-log-date";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/personal/food-log/$date")({
  component: () => {
    const { date } = Route.useParams();
    return <FoodLogDatePage date={date} />;
  },
  params: {
    parse: ({ date }) => ({ date: Temporal.PlainDate.from(date) }),
    stringify: ({ date }) => ({ date: date.toString() }),
  },
  loader: async ({ context, params }) => {
    if (!context.zero) return;
    void FoodLogOnDate.preload(context.zero, context.actor, params.date);
  },
  onError: () => {
    throw redirect({
      to: "/personal/food-log/$date",
      params: { date: Temporal.Now.plainDateISO() },
    });
  },
});
